import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useQuery } from "@tanstack/react-query";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const KEY = "easy-mood-recent";

export const recordView = (id) => {
  try {
    const list = JSON.parse(localStorage.getItem(KEY) || "[]");
    const next = [id, ...list.filter((x) => x !== id)].slice(0, 8);
    localStorage.setItem(KEY, JSON.stringify(next));
  } catch {
    /* storage unavailable */
  }
};

const fmt = (price) =>
  `$${Number.isInteger(price) ? price : price.toFixed(2)}`;

export default function RecentlyViewed({ currentId }) {
  const navigate = useNavigate();
  const { data: products = [] } = useQuery({
    queryKey: ["products"],
    queryFn: async () => (await axios.get(`${API}/products`)).data,
  });

  const recent = useMemo(() => {
    try {
      const ids = JSON.parse(localStorage.getItem(KEY) || "[]").filter(
        (x) => x !== currentId
      );
      return ids
        .map((id) => products.find((p) => p.id === id))
        .filter(Boolean)
        .slice(0, 4);
    } catch {
      return [];
    }
  }, [products, currentId]);

  if (!recent.length) return null;

  return (
    <section data-testid="recently-viewed" className="mt-20 border-t border-line pt-12">
      <p className="text-xs uppercase tracking-[0.3em] text-smoke">
        Recently viewed
      </p>
      <div className="mt-6 grid grid-cols-2 gap-4 md:grid-cols-4">
        {recent.map((p) => (
          <button
            key={p.id}
            data-testid={`recent-${p.id}`}
            onClick={() => navigate(`/product/${p.id}`)}
            className="group text-left"
          >
            <div className="aspect-square overflow-hidden bg-white">
              <img
                src={p.image}
                alt={p.name}
                loading="lazy"
                className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
              />
            </div>
            <p className="mt-3 line-clamp-1 font-serif text-lg font-medium tracking-tight text-ink">
              {p.name}
            </p>
            <p className="mt-0.5 text-sm text-smoke">{fmt(p.price)}</p>
          </button>
        ))}
      </div>
    </section>
  );
}
